import { translateKey } from '../translate';

export function createEnumeration(collection: string[]) {
    const seperator = (index: number) => {
        const lastItem = collection.length - 1;
        if (index === 0) {
            return '';
        }

        if (index === lastItem) {
            return ' ' + translateKey('common.and');
        }

        return ',';
    };

    return collection.reduce((acc, curr, index) => `${acc}${seperator(index)} ${curr}`, '');
}
